// services/feedbackApi.ts
import type { FeedbackSubmission } from "../store/types/feedbackTypes";
import { getSessionId } from "./sessionService";

/**
 * Feedback API Service
 *
 * Handles feedback form submissions
 */
export const feedbackApi = {
    /**
     * Submit general feedback form
     */
    async submitFeedback(payload: FeedbackSubmission): Promise<unknown> {
        const response = await fetch("/api/feedback", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Guest-Id": getSessionId()
            },
            credentials: "include",
            body: JSON.stringify({
                message: payload.message,
                sessionId: payload.sessionId
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({})) as { message?: string };
            throw new Error(errorData.message ?? "Failed to submit feedback");
        }

        return response.json() as Promise<unknown>;
    }
};
